export default "__VITE_PUBLIC_ASSET__59093429__"